'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LargeSearchBox = function (_React$Component) {
  (0, _inherits3.default)(LargeSearchBox, _React$Component);

  function LargeSearchBox() {
    (0, _classCallCheck3.default)(this, LargeSearchBox);
    return (0, _possibleConstructorReturn3.default)(this, (LargeSearchBox.__proto__ || (0, _getPrototypeOf2.default)(LargeSearchBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(LargeSearchBox, [{
    key: 'onSuggestedTagClicked',
    value: function onSuggestedTagClicked(ev, tag) {
      var _props = this.props,
          onSearch = _props.onSearch,
          currentType = _props.currentType,
          tags = _props.state.tags;


      onSearch(tags.concat(tag), currentType);
    }
  }, {
    key: 'onBackspaceDown',
    value: function onBackspaceDown() {}
  }, {
    key: 'renderSuggestedTags',
    value: function renderSuggestedTags() {
      var _classnames,
          _this2 = this;

      var _props2 = this.props,
          searchSuggestions = _props2.searchSuggestions,
          loadingSearchSuggestions = _props2.loadingSearchSuggestions;


      var styles = require('./LargeSearchBox.scss');

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.LargeSearchBox__suggestedTags, true), (0, _defineProperty3.default)(_classnames, styles['LargeSearchBox__suggestedTags--loading'], loadingSearchSuggestions), _classnames));

      var onSuggestedTagClicked = function onSuggestedTagClicked(t) {
        return function (ev) {
          return _this2.onSuggestedTagClicked(ev, t);
        };
      };

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'ul',
          null,
          searchSuggestions.map(function (s) {
            return _react2.default.createElement(
              'span',
              {
                onClick: onSuggestedTagClicked(s.tag),
                className: styles.Tag + ' ' + styles['Tag--suggested'] },
              s.tag
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./LargeSearchBox.scss');
      var tags = this.props.state.tags;


      var onTagClicked = function onTagClicked(t) {
        return function (ev) {
          return _this3.onTagClicked(ev, t);
        };
      };

      var _props3 = this.props,
          onSearchChange = _props3.onSearchChange,
          fetchingSuggestions = _props3.fetchingSuggestions,
          suggestions = _props3.state.suggestions;


      return _react2.default.createElement(
        'div',
        { className: styles.LargeSearchBox },
        this.renderSuggestedTags()
      );
    }
  }]);
  return LargeSearchBox;
}(_react2.default.Component);

exports.default = LargeSearchBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeSearchBox/LargeSearchBox.jsx
// module id = 2622
// module chunks = 0